export default "__VITE_ASSET__63434e54__"